/// <reference path="index.d.ts" />
import * as React from 'react';
import doLog from '../../common/log';
const ZOOM_STEP = 0.2;
const ZOOM_MAX = 3;
const ZOOM_MIN = 1;

interface Props {
  setImageZoom: React.Dispatch<React.SetStateAction<ZoomProps>>
  imageZoom: ZoomProps
}

export default function ImageZoom ( props: Props ) {
  const { setImageZoom,imageZoom } = props;

  const bigger = () => {
    doLog(
      '/sc.details.commonLogs',
      `info=&action=mainImageDialogBigger`,
    );
    const newScale = Number( ( imageZoom.scale + ZOOM_STEP ).toFixed( 1 ) );
    setImageZoom( {
      ...imageZoom,
      scale: newScale >= ZOOM_MAX ? ZOOM_MAX : newScale,
      enableSmaller: true,
      enableBigger: imageZoom.scale < ZOOM_MAX,
    } )
  };

  const smaller = () => {
    const newScale = Number( ( imageZoom.scale - ZOOM_STEP ).toFixed( 1 ) );
    setImageZoom( {
      ...imageZoom,
      scale: newScale <= ZOOM_MIN ? ZOOM_MIN : newScale,
      enableBigger: true,
      enableSmaller: imageZoom.scale > ZOOM_MIN,
    } )
  };

  const { enableBigger,enableSmaller } = imageZoom;

  return (
    <div className="slide-zoom-container">
      <div className="slide-zoom">
        {enableBigger ? (
          <img
            className="bigger-btn"
            src="https://img.alicdn.com/tfs/TB1IFvs2xD1gK0jSZFsXXbldVXa-24-24.svg"
            onClick={bigger}
          />
        ) : (
          <img
            className="bigger-btn"
            src="https://img.alicdn.com/tfs/TB1IFvs2xD1gK0jSZFsXXbldVXa-24-24.svg"
            style={{ cursor: 'not-allowed',opacity: 0.3 }}
          />
        )}
        {enableSmaller ? (
          <img
            className="smaller-btn"
            src="https://img.alicdn.com/tfs/TB1bPMcmZieb18jSZFvXXaI3FXa-24-24.svg"
            onClick={smaller}
          />
        ) : (
          <img
            className="smaller-btn"
            src="https://img.alicdn.com/tfs/TB1bPMcmZieb18jSZFvXXaI3FXa-24-24.svg"
            style={{ cursor: 'not-allowed',opacity: 0.3 }}
          />
        )}
      </div>
    </div>
  )
}
